This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div>
    <div class="basicBlock">
      <p class="header upper">{{ $t("lessonPackages.allLevels") }}</p>
      <div
        class="blockEntry selectable grid-cols-5 buttonsRight leftRight"
        v-for="p in this.published"
        :key="p.id"
      >
        <p>{{ p.name }}</p>
        <button class="button success" @click="useLevel(p)">
          <img src="@/assets/images/icons/PlusGrey.svg" alt="Add level icon" />
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { levelAPI } from "@/utils/apiCalls";
import { bundleLevelSettings, level } from "@/utils/Types";

@Options({
  data() {
    return {
      published: [],
    };
  },
  methods: {
    /**
     * Add level to bundle
     * @param i Bundle level settings
     */
    useLevel(i: bundleLevelSettings) {
      var index = this.published.indexOf(i, 0);
      this.$emit("usePublishedLevel", i);
      this.published.splice(index, 1);
    },
    /**
     * Remove published level
     * @param variable Bundle level settings
     */
    removePublishedLevel(variable: bundleLevelSettings) {
      this.published.push(variable);
    },
    /**
     * Update published levels
     * @param levels Bundle level settings list
     */
    async updatePublishedLevels(levels: bundleLevelSettings[]) {
      levelAPI.getAddableLevels().then((value) => {
        const levelSet = new Set(
          levels?.map((level: bundleLevelSettings) => level.levelId)
        );
        this.published = value?.filter(
          (level: level) => !levelSet.has(level.levelId)
        );
      });
    },
  },
  props: ["levels"],
})
export default class PublishedLevelsBlock extends Vue {}
</script>
